const BookStates = Object.freeze({
  notStarted: {
    color: '#6C6C6C',
  },
  notCompleted: { color: '#f79317' },
  completed: { color: '#06d6a0' },
});

export default BookStates;
